import {Injectable} from '@angular/core';
import {AbstractAdvTechService} from '../../../../shared/services/advtech/abstract-advtech.service';

/**
 * Service to retrieve template types
 */
@Injectable()
export class TemplateListService extends AbstractAdvTechService {
  /**
   * hub prefix for the calls
   * @type {string}
   */
  protected prefix = 'mobile/content/template';

  /**
   * Gets the list of templates for the content type
   * @returns {Observable<Response>}
   */
  getTemplates() {
      return this.callGetEndpoint('retrieve-user-templates', true);
  }
}



// WEBPACK FOOTER //
// ./src/app/content/shared/services/template-list/template-list.service.ts